function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#075da9;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Product Icons");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M22.8,57.37a.88.88,0,0,1-.88.89H20.87a.89.89,0,1,1,0-1.78h1.05A.88.88,0,0,1,22.8,57.37ZM38.34,50H37.28a.89.89,0,0,0,0,1.78h1.06a.89.89,0,0,0,0-1.78ZM64,40.78V44a4,4,0,0,1-3.94,3.94h-7.7v2.76a3.93,3.93,0,0,1-3.93,3.93h-18v2.55a4,4,0,0,1-3.94,3.94H16.31a3.94,3.94,0,0,1-3.93-3.94V47.92H3.94A4,4,0,0,1,0,44v-3.2a.89.89,0,0,1,.89-.89h2.8v-33A4,4,0,0,1,7.63,2.9H56.37a3.94,3.94,0,0,1,3.94,3.93V39.89h2.8A.89.89,0,0,1,64,40.78ZM5.47,6.84v0H58.53v0a2.16,2.16,0,0,0-2.16-2.16H7.63A2.16,2.16,0,0,0,5.47,6.84Zm0,33.05h6.91V34.57a3.94,3.94,0,0,1,3.93-3.94h4.05a.89.89,0,1,1,0,1.78H16.31a2.16,2.16,0,0,0-2.16,2.16V52.84H28.63V37.15a.89.89,0,0,1,1.78,0v9.21H50.59V21.64a2.17,2.17,0,0,0-2.16-2.17H41.86a.89.89,0,1,1,0-1.77h6.57a3.94,3.94,0,0,1,3.93,3.94V39.89h6.17V8.65H5.47Zm6.91,6.25V41.67H1.77V44a2.17,2.17,0,0,0,2.17,2.16Zm16.25,11V54.61H14.15v2.55a2.16,2.16,0,0,0,2.16,2.16H26.47A2.16,2.16,0,0,0,28.63,57.16Zm22-6.48V48.13H30.41v4.71h18A2.16,2.16,0,0,0,50.59,50.68Zm11.64-9H52.36v4.47h7.7A2.17,2.17,0,0,0,62.23,44ZM23.67,34.91V13.83a.88.88,0,0,1,.43-.76.87.87,0,0,1,.87,0L44.83,23.56a.89.89,0,0,1,0,1.57L25,35.7a.87.87,0,0,1-.42.1.87.87,0,0,1-.88-.89Zm1.77-1.47,17.09-9.09-17.09-9Z"
});

var SvgMultiDrmIcon = function SvgMultiDrmIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMultiDrmIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/multi-drm-icon.8e5ae8e4.svg";
export { ForwardRef as ReactComponent };